export default function JSDB() {
    return (window as any).NiHulKavJsConvertorApp.JsDB;
}

export function ApiCallWrapper(task: string, callback: any) {
    const A = (window as any).NiHulKavJsConvertorApp.ApiCallWrapper;
    const pi = new A(task, callback);
    return pi;
}

export class ApiCall {
    task: string;

    api: any;

    callback: any;

    constructor(task: string) {
        this.task = task;
        const callback = (result) => {

        };
        this.api = ApiCallWrapper(task, callback);

    }

    putParam(name: string, value: any): ApiCall {
        this.api.putParam(name, value);
        return this;
    }

    /**
     * Why the task returned null, when the Kotlin side caught something. The
     * rejection itself carries no message, so this is the only way to tell a
     * crash apart from a plain failure. Guarded because a cached older bundle
     * has no such method.
     */
    lastError(): string | undefined {
        try {
            return this.api.lastError() ?? undefined;
        } catch {
            return undefined;
        }
    }

    execute(other_allow_status=undefined,other_allow_status2=undefined,timeout=undefined): Promise<any> {
        return new Promise((resolve, reject) => {
            let timeoutId;
            let isSettled = false;
            if (timeout !== undefined) {
                timeoutId = setTimeout(() => {
                    if (!isSettled) {
                        isSettled = true;
                        reject(new Error('Promise timed out'));
                    }
                }, timeout);
            }
            const callback = (result) => {
                if (isSettled) return;
                isSettled = true;
                if (timeoutId) clearTimeout(timeoutId);
                if (result == null) {
                    reject(result);
                } else if (result.second != null) {
                    if (result.second.name !== 'SUCCESS' && (other_allow_status==undefined  || other_allow_status!=(result.second.name)) && (other_allow_status2==undefined  || other_allow_status2!=(result.second.name)))
                        reject(result.second);
                    else
                        resolve(result);
                } else if (result.name !== 'SUCCESS' && (other_allow_status==undefined  || other_allow_status!=(result.name)) && (other_allow_status2==undefined  || other_allow_status2!=(result.name))) {
                    reject(result.first);
                } else {
                    resolve(result);
                }
            };
            this.api.replaceCallback(callback);
            this.api.execute();
        });
    }

}

export function NKTypeConvertor() {
    return (window as any).NiHulKavJsConvertorApp.NKTypeConvertor;
}
